import React from 'react'
import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'
import { Modal } from 'react-responsive-modal'
import { scrollbarSize } from '../util/dom'
import smartscreenImg from '../img/smartscreen-warning.jpg'
import { trackDownload } from '../lib/tracking'
import { useTranslation, Trans } from '../lib/i18n'

const scrollbarWidth = scrollbarSize()

const GlobalModalStyles = createGlobalStyle`
    .smartscreen-modal-overlay {
        background: rgba(1, 1, 1, 0.8);
        animation-duration: 300ms !important;
    }

    .react-responsive-modal-modal.smartscreen-modal {
        border-radius: 12px;
        padding: 2rem 2rem 1.5rem;
        max-width: 480px;
        width: 90vw;
        background: #1a1d23;
    }

    .react-responsive-modal-width-fix {
        width: calc(100% - ${scrollbarWidth}px);
    }
`

const Title = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 8px;
`

const Subtitle = styled.p`
    font-size: 14px;
    color: #aaa;
    margin: 0 0 20px;
    line-height: 1.5;
`

const Steps = styled.ol`
    margin: 0 0 20px;
    padding-left: 20px;
`

const Step = styled.li`
    font-size: 14px;
    color: #ccc;
    margin-bottom: 6px;
    line-height: 1.5;

    strong {
        color: #fff;
    }
`

const Screenshot = styled.img`
    width: 100%;
    border-radius: 8px;
    margin-bottom: 16px;
    border: 1px solid #333;
`

const Note = styled.p`
    font-size: 12px;
    color: #888;
    margin: 0 0 24px;
    line-height: 1.5;
`

const Actions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
`

const DownloadButton = styled.a`
    display: inline-block;
    padding: 10px 20px;
    background: #0078d4;
    color: white;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    transition: opacity 0.2s ease;
    cursor: pointer;

    &:hover {
        opacity: 0.9;
        color: white;
    }
`

const CancelButton = styled.button`
    padding: 10px 20px;
    background: transparent;
    color: #888;
    border: 1px solid #444;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #666;
        color: #aaa;
    }
`

const SmartscreenModal = ({ open, onClose, downloadHref }) => {
    const { t } = useTranslation(undefined, { keyPrefix: 'smartscreen' })

    return (
    <>
        <GlobalModalStyles />
        <Modal
            center
            open={open}
            onClose={onClose}
            classNames={{
                overlay: 'smartscreen-modal-overlay',
                modal: 'smartscreen-modal',
            }}
        >
            <Title>{t('title')}</Title>
            <Subtitle>{t('subtitle')}</Subtitle>

            <Screenshot src={smartscreenImg} alt={t('imageAlt')} />

            <Steps>
                <Step><Trans i18nKey="smartscreen.step1" components={[<strong key="0" />]} /></Step>
                <Step><Trans i18nKey="smartscreen.step2" components={[<strong key="0" />]} /></Step>
            </Steps>

            <Note>{t('note')}</Note>

            <Actions>
                <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
                <DownloadButton href={downloadHref} onClick={() => { trackDownload('windows'); onClose() }}>
                    {t('download')}
                </DownloadButton>
            </Actions>
        </Modal>
    </>
)
}

export default SmartscreenModal
